import { axiosInstance } from '../common/api';

export const getProjectLinks = async (projectId) => {
  const url = `/project_links/${projectId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// Create a new project link
export const createProjectLink = async (linkData) => {
  const url = '/project_links';
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, linkData)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const updateProjectLink = async (linkId, linkData) => {
  const url = `/project_links/${linkId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, linkData)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
// Delete a project link
export const deleteProjectLink = async (linkId) => {
  const url = `/project_links/${linkId}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
